import { GetGreenroomMeetingData } from '@/connection/greenroom/get-greenroom-meeting-data';
import { ProjectStateReducerCreator } from '../types';
import type { RootState } from '@/store/root-state';

const loadGreenroomMeetingReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ sessionUuid, token }: { sessionUuid: string; token: string }, { rejectWithValue }) => {
      if (!token) {
        return rejectWithValue('No ID Token');
      }

      return GetGreenroomMeetingData(sessionUuid);
    },
    {
      options: {
        condition: ({ sessionUuid }, { getState }) => {
          const state = getState() as RootState;
          return state.project.greenroomMeetingLoadingUuid !== sessionUuid;
        },
      },
      fulfilled: (state, action) => {
        state.greenroomMeeting = action.payload;
        state.greenroomMeetingError = false;
      },
      pending: (state, action) => {
        state.greenroomMeetingLoading = true;
        state.greenroomMeetingLoadingUuid = action.meta.arg.sessionUuid;
      },
      settled: (state) => {
        state.greenroomMeetingLoading = false;
        state.greenroomMeetingLoadingUuid = undefined;
      },
      rejected: (state, action) => {
        console.error(action);
        state.greenroomMeetingError = true;
      },
    }
  );
};

export default loadGreenroomMeetingReducer;
